// Generated by purs version 0.13.8
"use strict";
var Data_Array = require("../Data.Array/index.js");
var Data_Foldable = require("../Data.Foldable/index.js");
var Data_Functor = require("../Data.Functor/index.js");
var Data_Generic_Rep_Show = require("../Data.Generic.Rep.Show/index.js");
var Data_Map_Internal = require("../Data.Map.Internal/index.js");
var Data_Monoid = require("../Data.Monoid/index.js");
var Data_Ord = require("../Data.Ord/index.js");
var Data_Semigroup = require("../Data.Semigroup/index.js");
var Data_Show = require("../Data.Show/index.js");
var Data_Tuple = require("../Data.Tuple/index.js");
var Data_Unfoldable = require("../Data.Unfoldable/index.js");
var Lunarbox_Capability_Editor_Type = require("../Lunarbox.Capability.Editor.Type/index.js");
var Lunarbox_Control_Monad_Dataflow_Infer = require("../Lunarbox.Control.Monad.Dataflow.Infer/index.js");
var Lunarbox_Control_Monad_Dataflow_Infer_InferExpression = require("../Lunarbox.Control.Monad.Dataflow.Infer.InferExpression/index.js");
var Lunarbox_Control_Monad_Dataflow_Solve = require("../Lunarbox.Control.Monad.Dataflow.Solve/index.js");
var Lunarbox_Control_Monad_Dataflow_Solve_SolveConstraintSet = require("../Lunarbox.Control.Monad.Dataflow.Solve.SolveConstraintSet/index.js");
var Lunarbox_Data_Dataflow_Class_Substituable = require("../Lunarbox.Data.Dataflow.Class.Substituable/index.js");
var Lunarbox_Data_Dataflow_Expression = require("../Lunarbox.Data.Dataflow.Expression/index.js");
var Lunarbox_Data_Dataflow_Type = require("../Lunarbox.Data.Dataflow.Type/index.js");
var Lunarbox_Data_Dataflow_TypeEnv = require("../Lunarbox.Data.Dataflow.TypeEnv/index.js");
var solveExpression = function (dictOrd) {
    return function (dictShow) {
        return function (expression) {
            var location = Lunarbox_Data_Dataflow_Expression.getLocation(expression);
            var solveContext = {
                location: location
            };
            var inferEnv = {
                typeEnv: Data_Monoid.mempty(Lunarbox_Data_Dataflow_TypeEnv.monoidTypeEnv),
                location: location
            };
            var v = Lunarbox_Control_Monad_Dataflow_Infer.runInfer(inferEnv)(Lunarbox_Control_Monad_Dataflow_Infer_InferExpression.infer(dictOrd)(dictShow)(expression));
            var v1 = Lunarbox_Control_Monad_Dataflow_Solve.runSolve(solveContext)(Lunarbox_Control_Monad_Dataflow_Solve_SolveConstraintSet.solve(v.value1.constraints));
            return new Data_Tuple.Tuple(Data_Functor.map(Data_Map_Internal.functorMap)(Lunarbox_Data_Dataflow_Class_Substituable.apply(Lunarbox_Data_Dataflow_Class_Substituable.typeSubst)(v1.value0))(v.value1.typeMap), Data_Semigroup.append(Lunarbox_Control_Monad_Dataflow_Solve.semigroupSolveState)({
                errors: v.value1.errors
            })(v1.value1));
        };
    };
};
var printTypeMap = function (dictShow) {
    return function (dictGeneric) {
        return function (dictGenericShow) {
            return function (dictOrd) {
                var $29 = Data_Foldable.foldr(Data_Foldable.foldableArray)(function (v) {
                    return function (result) {
                        return result + ("\x0a" + (Data_Generic_Rep_Show.genericShow(dictGeneric)(dictGenericShow)(v.value0) + (" = " + Data_Show.show(Lunarbox_Data_Dataflow_Type.typeShow)(Lunarbox_Capability_Editor_Type.prettify(v.value1)))));
                    };
                })("");
                var $30 = Data_Array.sortBy(function (v) {
                    return function (v1) {
                        return Data_Ord.compare(Data_Ord.ordString)(Data_Show.show(Lunarbox_Data_Dataflow_Type.typeShow)(v.value1))(Data_Show.show(Lunarbox_Data_Dataflow_Type.typeShow)(v1.value1));
                    };
                });
                var $31 = Data_Map_Internal.toUnfoldable(Data_Unfoldable.unfoldableArray);
                return function ($32) {
                    return $29($30($31($32)));
                };
            };
        };
    };
};
module.exports = {
    solveExpression: solveExpression,
    printTypeMap: printTypeMap
};
